import { 
    findAllMaxMinPrices
} from '../../_services/max_min_prices.service';

export const findAllMaxMinPricesEvent = async () => {
    let res = await findAllMaxMinPrices();
    if(! res.ok) throw new Error(res.error);
    return res;
}
